import { render, staticRenderFns } from "./consigneParent.vue?vue&type=template&id=9518fa58&"
import script from "./consigneParent.vue?vue&type=script&lang=js&"
export * from "./consigneParent.vue?vue&type=script&lang=js&"
import style0 from "./consigneParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports